import { getLogoutState, markServerLogoutComplete } from "../utils/authStorage"

let pendingRequest = null
// Cookie cleanup is separate from audit edits: it must run while signed out.
export async function completePendingLogout() {
  const state = getLogoutState()
  if (!state?.pending) return true
  if (navigator.onLine === false) return false
  if (pendingRequest) return pendingRequest
  pendingRequest = (async () => {
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), 15000)
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:8005/api"}/auth/logout`, {
        method: "POST", credentials: "include", signal: controller.signal,
      })
      if (!response.ok) return false
      markServerLogoutComplete(state.id)
      return true
    } catch { return false } finally { clearTimeout(timeout) }
  })()
  try { return await pendingRequest } finally { pendingRequest = null }
}
